var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3661 1.24112C10.6005 1.0067 10.9185 0.875 11.25 0.875H18.75C19.0815 0.875 19.3995 1.0067 19.6339 1.24112C19.856 1.46326 19.9859 1.7604 19.9989 2.07302L20.5421 5.875H28.125C28.6223 5.875 29.0992 6.07254 29.4508 6.42417C29.8025 6.77581 30 7.25272 30 7.75V25.25C30 25.7473 29.8025 26.2242 29.4508 26.5758C29.0992 26.9275 28.6223 27.125 28.125 27.125H1.875C1.37772 27.125 0.900806 26.9275 0.549175 26.5758C0.197544 26.2242 0 25.7473 0 25.25V7.75C0 7.25272 0.197544 6.77581 0.549175 6.42417C0.900805 6.07254 1.37772 5.875 1.875 5.875H9.45794L10.0011 2.07302C10.0141 1.7604 10.144 1.46326 10.3661 1.24112ZM9.99081 7.125C9.99748 7.12511 10.0041 7.12511 10.0108 7.125H19.9892C19.9959 7.12511 20.0025 7.12511 20.0092 7.125H28.125C28.2908 7.125 28.4497 7.19085 28.5669 7.30806C28.6842 7.42527 28.75 7.58424 28.75 7.75V25.25C28.75 25.4158 28.6842 25.5747 28.5669 25.6919C28.4497 25.8092 28.2908 25.875 28.125 25.875H1.875C1.70924 25.875 1.55027 25.8092 1.43306 25.6919C1.31585 25.5747 1.25 25.4158 1.25 25.25V7.75C1.25 7.58424 1.31585 7.42527 1.43306 7.30806C1.55027 7.19085 1.70924 7.125 1.875 7.125H9.99081ZM19.2794 5.875H10.7206L11.2437 2.21339C11.2479 2.18411 11.25 2.15457 11.25 2.125L18.75 2.125C18.75 2.15457 18.7521 2.18411 18.7563 2.21339L19.2794 5.875Z",
    fill: "#3F9339"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 11.5024C4.99999 11.1573 5.27982 10.8774 5.62499 10.8774H24.375C24.7202 10.8774 25 11.1573 25 11.5024C25 11.8476 24.7202 12.1274 24.375 12.1274H5.62499C5.27982 12.1274 4.99999 11.8476 4.99999 11.5024Z",
    fill: "#3F9339"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 16.5024C4.99999 16.1572 5.27982 15.8774 5.62499 15.8774H24.375C24.7202 15.8774 25 16.1572 25 16.5024C25 16.8476 24.7202 17.1274 24.375 17.1274H5.62499C5.27982 17.1274 4.99999 16.8476 4.99999 16.5024Z",
    fill: "#3F9339"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 21.5024C4.99999 21.1572 5.27982 20.8774 5.62499 20.8774H24.375C24.7202 20.8774 25 21.1572 25 21.5024C25 21.8476 24.7202 22.1274 24.375 22.1274H5.62499C5.27982 22.1274 4.99999 21.8476 4.99999 21.5024Z",
    fill: "#3F9339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateGreen);
export default __webpack_public_path__ + "static/media/corporate-green.92182ea4749c9789b18ffb585369a6e2.svg";
export { ForwardRef as ReactComponent };